export const CHARGE_ENTRY_TABS_LIMIT = 5;
export const ERA_TABS_LIMIT = 3;
// Reports
export const AGING_INSURANCE_REPORT = "Ageing Insurance Report";
export const ENCOUNTERS = "Encounters";
export const CLAIMS = "Claims";
export const AGING_REPORT = "Ageing Reports";
export const DENIAL_MANAGEMENT = "Denial Management";
export const BILLING = "Billing";
export const ERAS = "ERAs";
export const RECEIVED_ERA_CLAIMS = "Received ERA Claims";
export const PATIENTS = "Patients";
// Phases
export const INSURANCE_PRIMARY = "Insurance - Primary";
export const INSURANCE_SECONDARY = "Insurance - Secondary";
export const INSURACNE_TERTIARY = "Insurance - Tertiary";
export const PATIENT_PAYMENT = "Patient Payment";
export const CLOSED = "Closed";
// Status
export const DRAFT = "Draft";
export const MISSING_ATTACHMENT = "Missing Attachment";
export const BILL_PENDING = "Bill Pending";
export const COMPLETED = "Completed";
export const PAPER_SUBMISSION = "PaperSubmission";
export const PAPER_SUBMITTED = "PaperSubmitted";
export const NEEDS_INFORMATION = "Needs Information";
export const REJECTED = "Rejected";
export const SECONDARY_DRAFT = "Secondary Claims - Draft";
export const TOTAL_DRAFT = "Draft";
export const DENIED = "Denied";
export const PENDING_REVIEW = "Pending Review";
export const BILL_Pending = "Bill Pending";
export const BILL_READY = "Bill Ready";
export const BILL_SENT = "Bill Sent";
export const ACCEPTED = "Accepted";
export const ALL = "All";
// Question types
export const radio = "radio";
export const text = "text";
export const checkbox = "checkbox";
export const radio_other = "radio_other";
export const date = "date";
export const checkbox_description = "checkbox_description";
// Form Types
export const wc_c4 = "wc_c4";

export const paymentMethodsArray = [
  { label: "Cash", code: "PPCA" },
  { label: "Check", code: "PPCK" },
  { label: "Credit Card", code: "PPCR" },
  { label: "ACH", code: "ACH" },
  { label: "N/A", code: "N/A" },
];

export const transactionTypesArray = [
  // { label: "Co-Payment", code: "COPAY"},
  // { label: "Patient Responsibility", code: "PRESP"},
  // { label: "Write Off", code: "WO"},
  // { label: "Insurance Write Off", code: "IWO"},
  { label: "Patient Advance Payment - OON", code: "PAP" },
  { label: "Insurance Payment to Patient", code: "IPPAT" },
  { label: "Other Type of Transaction", code: "OTH" },
  { label: "Insurance Payment Full", code: "IP" },
  { label: "Insurance Payment Partial", code: "IPP" },
  { label: "Insurance Take Back", code: "ITB" },
  { label: "Insurance Write Off", code: "IWO" },
  { label: "Professional Courtesy", code: "PC" },
  { label: "General Write Off", code: "WO" },
  { label: "Patient Copay Payment", code: "PCP" },
  { label: "Returned Check", code: "RTCK" },
  { label: "Patient Responsibility Payment", code: "PRP" },
  { label: "Private Check", code: "PVCK" },
  { label: "Practice Applied Discount", code: "PAD" },
];

export const insurance_list = [
  { label: "Primary", code: "Primary" },
  { label: "Secondary", code: "Secondary" },
  { label: "Tertiary", code: "Tertiary" },
];

export const payment_src_list = [
  { label: "Insurance", code: "Insurance" },
  { label: "Patient", code: "Patient" },
  { label: "Practice", code: "Practice" },
];

export const paymentMethods = {
  PPCA: "Cash",
  PPCK: "Check",
  PPCR: "Credit Card",
  "N/A": "N/A",
  ACH: "ACH",
};

export const transactionTypes = {
  PAP: "Patient Advance Payment - OON",
  IPPAT: "Insurance Payment to Patient",
  COPAY: "Co-Payment",
  PRESP: "Patient Responsibility",
  // "WO": "Write Off",
  // "IWO": "Insurance Write Off",
  OTH: "Other Type of Transaction",
  IP: "Insurance Payment Full",
  IPP: "Insurance Payment Partial",
  ITB: "Insurance Take Back",
  IWO: "Insurance Write Off",
  PC: "Professional Courtesy",
  WO: "General Write Off",
  PCP: "Patient Copay Payment",
  RTCK: "Returned Check",
  PRP: "Patient Responsibility Payment",
  PVCK: "Private Check",
  ACH: "Automatic Deposit",
  CHK: "Check",
  NON: "No Payment",
  PAD: "Practice Applied Discount",
};

export const status_list = [
  { label: "Accepted", value: ACCEPTED },
  { label: "Bill Pending", value: BILL_PENDING },
  { label: "Bill Sent", value: BILL_SENT },
  { label: "Closed", value: CLOSED },
  //{ label: "Completed", value: COMPLETED },
  { label: "Missing Attachment", value: MISSING_ATTACHMENT },
  { label: "Needs Information", value: NEEDS_INFORMATION },
  { label: "Paper Submission", value: PAPER_SUBMISSION },
  { label: "Rejected", value: REJECTED },
  { label: "Pending Review", value: PENDING_REVIEW },
  { label: "Paper Submitted", value: PAPER_SUBMITTED },
];

export const reason_list = [
  { label: "Clearinghouse doesn't support Payer", reason_id: "002" },
  { label: "General", reason_id: "001" },
  { label: "Process completed offline", reason_id: "005" },
  { label: "Submitted paper claim", reason_id: "003" },
  { label: "Waiting for information", reason_id: "004" },
];

export const phase_data = {
  [PAPER_SUBMISSION]: [
    INSURANCE_PRIMARY,
    INSURANCE_SECONDARY,
    INSURACNE_TERTIARY,
  ],
  [NEEDS_INFORMATION]: [
    INSURANCE_PRIMARY,
    INSURANCE_SECONDARY,
    INSURACNE_TERTIARY,
  ],
  [COMPLETED]: [INSURANCE_PRIMARY, INSURANCE_SECONDARY, INSURACNE_TERTIARY],
  [CLOSED]: [CLOSED],
  [BILL_PENDING]: [PATIENT_PAYMENT],
  [MISSING_ATTACHMENT]: [
    INSURANCE_PRIMARY,
    INSURANCE_SECONDARY,
    INSURACNE_TERTIARY,
  ],
  [ACCEPTED]: [INSURANCE_PRIMARY, INSURANCE_SECONDARY, INSURACNE_TERTIARY],
  [REJECTED]: [INSURANCE_PRIMARY, INSURANCE_SECONDARY, INSURACNE_TERTIARY],
  [PENDING_REVIEW]: [
    INSURANCE_PRIMARY,
    INSURANCE_SECONDARY,
    INSURACNE_TERTIARY,
  ],
};

export const relation = [
  { label: "Self", value: "Self" },
  { label: "Spouse", value: "Spouse" },
  { label: "Child", value: "Child" },
  { label: "Other", value: "Unknown" },
];

export const insuranceType = [
  { label: "Medicare", value: "medicare" },
  { label: "Medicaid", value: "medicaid" },
  { label: "BCBS", value: "bcbs" },
  { label: "Tricare", value: "tricare" },
  { label: "Champus", value: "champus" },
  { label: "Group Health Plan", value: "grpPlan" },
  { label: "Champva", value: "champva" },
  { label: "FECA BLK Lung", value: "feca" },
  { label: "Commercial", value: "commercial" },
  { label: "Commercial Non Claimmd", value: "commericial_non_claimmd" },
  { label: "Workers Comp", value: "workerscomp" },
  { label: "Other", value: "other" },
];

export const medicareReasons = [
  { label: "Working Age", value: "12" },
  { label: "Medicare Disabled", value: "43" },
  { label: "Conditional/Accident", value: "11" },
  { label: "ESRD Beneficiary", value: "13" },
  { label: "Auto Accident", value: "14" },
  { label: "Workers Comp/Black Lung", value: "15" },
  { label: "Other Federal Agency", value: "16" },
  { label: "WCMSA", value: "19" },
  { label: "Black Lung", value: "41" },
  { label: "Veteran's Administration", value: "42" },
  { label: "Liability", value: "47" },
];

export const providerTypesArray = [
  { label: "Individual", value: "Individual" },
  { label: "Organization", value: "Organization" },
];
